import React from "react";

const Table = ({ headers, rows = [] }) => {
    return (
        <div className="overflow-hidden sm:rounded shadow-md">
            <table className="min-w-full">
                <thead className="bg-gray-100">
                    <tr>
                        {headers.map((header) => (
                            <th
                                key={header.name}
                                scope="col"
                                className="text-xs font-medium text-gray-700 px-6 py-3 text-left uppercase tracking-wider"
                            >
                                {header.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={index} className="bg-white border-b">
                            {headers.map((header) => (
                                <td
                                    key={header.name}
                                    className="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900"
                                >
                                    {row[header.name]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Table;
